import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface ConfirmCancelScheduledModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function ConfirmCancelScheduledModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: ConfirmCancelScheduledModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-6">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-yellow-600" />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-bold text-[#231F20] mb-2">
                Weet je zeker dat je deze ingeplande campaign wilt annuleren?
              </h2>
              <p className="text-sm text-gray-600">
                De campaign wordt teruggezet naar concepten.
              </p>
            </div>
            <button
              onClick={onClose}
              disabled={isLoading}
              className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors disabled:opacity-50"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="flex gap-3 justify-end">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="btn-secondary"
            >
              Annuleren
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="btn-primary bg-yellow-600 hover:bg-yellow-700 border-yellow-600 hover:border-yellow-700"
            >
              {isLoading ? 'Annuleren...' : 'OK'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
